export {
  JINGLE_DURATION,
  AD_JINGLE_DURATION,
  INTERFACE_DISPLAY_DURATION,
  SEEK_DEBOUNCE_MS,
  SEEK_THROTTLE_MS,
  SEEK_STEP_SECONDS,
  LIVE_DURATION,
} from '../../logic/player/player.constants';

// Longest wait for the CDN to tell the real manifest location, the playback fails over to the next source after it
export const MANIFEST_REDIRECT_TIMEOUT_MS = 10000;

export * from './platform/default/player.constants';
